import { Container, Row, Col } from "react-bootstrap";
import clsx from "classnames";
import styles from "./styles.module.scss";
import { CTA } from "@/ui";

export const EventsGrid = ({ className, title, events = [] }) => {
  return (
    <section className={clsx(styles.EventsGrid, className, 'py-4')}>
      <Container>
        {title && (
          <h2 className="text-center mb-4" data-sourceflow-prop="title">
            {title}
          </h2>
        )}
        <Row className="g-4">
          {events.map(({ icon, title, location, date, synopsis, cta, textColor, metaColor }, idx) => (
            <Col key={idx} md={6} lg={4}>
              <div className={clsx(styles.card, `text-${textColor}`)} data-sourceflow-content-id={idx}>
                <div>
                  <div className={styles.header}>
                    <h3 className={styles.cardTitle} data-sourceflow-prop="events.title">
                      {title}
                    </h3>
                    {icon?.url && <img src={icon.url} alt="" className={styles.icon} />}
                  </div>
                  <div className={clsx(styles.meta, `text-${metaColor}`)}>
                    <span>{location}</span>
                    <span>{date}</span>
                  </div>
                  <div className={styles.synopsis} dangerouslySetInnerHTML={{ __html: synopsis }} />
                </div>
                <div className={styles.cta}>
                  {cta?.label && (
                    <CTA label={cta.label} href={cta.href} variant={cta.variant} data-sourceflow-prop="events.cta" />
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default EventsGrid;
